import React, { useCallback } from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../../config/routes";
import { checkForPermission } from "../../utils/checkForPermission";
import { useAppSelector } from "../../hooks/redux";

interface IRoleBasedRoutingProps {
  Component: React.ReactNode;
  title: string;
  isRoleBasedRoute: boolean;
  [key: string]: any;
}

const RoleBasedRouting = ({
  Component,
  title,
  isRoleBasedRoute,
}: IRoleBasedRoutingProps) => {
  const state = useAppSelector((state) => state.auth);
  const userDetails = state.userDetails;
  const isAuthLoading = state.isLoading;

  // Function that decide whether to give permission or not based on current user's role
  const grantPermission = useCallback(() => {
    // Suspend judgment until auth resolves to prevent premature page mount and API calls
    if (isRoleBasedRoute && isAuthLoading) return null;
    if (
      isRoleBasedRoute &&
      userDetails &&
      userDetails.permissionRoles &&
      userDetails.permissionRoles.length > 0
    ) {
      return checkForPermission("Action", title);
    } else {
      return true;
    }
  }, [title, isRoleBasedRoute, userDetails, isAuthLoading]);

  const permission = grantPermission();

  if (permission === null) return null;

  return (
    <>
      {permission ? (
        <>{Component}</>
      ) : (
        <Navigate to={ROUTES["accessDenied"].url} />
      )}
    </>
  );
};

export default RoleBasedRouting;
